import { useCallback } from 'react';
import api from "../../../services/api";
import toast from "react-hot-toast";

export const useFakeMutation = () => {
  return useCallback((newRow: any, oldRow: any) => {
    const sendedData: any = {};
    Object.keys(newRow).forEach((dataItem) => {
      if (JSON.stringify(oldRow[dataItem]) !== JSON.stringify(newRow[dataItem])) {
        sendedData[dataItem] = newRow[dataItem];
      }
    });

    // Fire and forget API call
    api
      .patch(`/service-provider/service-reservation-confirmations/${newRow['service_reservation_id']}/${newRow['id']}`, sendedData)
      .then((res: any) => {
        const failedFields = Object.keys(res?.unsaved_fields || {});
        if (failedFields.length > 0) {
          toast.error('Some fields were not saved.');
          // optionally notify parent component
        } else {
          toast.success('Sikeres mentés.');
        }
      })
      .catch(() => {
        toast.error('Sikertelen mentés.');
        // optionally notify parent component
      });

    // Do nothing here, we don't want to block the update
  }, []);
};